module.exports = __webpack_public_path__ + "img/uchwyt-na-rower.f3756f85.jpg";